import { IEnvironment } from '../environment.interface';

export const environment: IEnvironment = {
  production: true,
  apiUrls: {
    bardo: 'https://api-bardo.nomoh.dev.br/api',
    nomoh: 'https://api-nomoh.nomoh.dev.br/api',
    zap: 'https://api-zap.nomoh.dev.br',
    nomohCliente: 'https://api-nomoh.nomoh.dev.br/api',
    bardoCliente: 'https://api-bardo.nomoh.dev.br/api',
  },
  internalDomains: ['nomoh.dev.br'],
  apiPortalIntegracao: '',
  bearerIntegracao: '',
  auth: {
    tokenKey: 'nomoh_token',
    refreshTokenKey: 'nomoh_refresh',
    sessionTimeout: 30 * 60 * 1000, // 30 minutos
  },
  features: {
    enableWhatsApp: true, // ✅ WhatsApp ativo em
    enableN8N: true, // ✅ N8N ativo em
    enableAudit: true, // ✅ Auditoria completa em
    enableDebugMode: false, // ❌ Debug off em qua (segurança)
  },
  analytics: {
    clarityEnabled: true, // ✅ Clarity ativo em homologação (valide aqui antes da prod)
    clarityIds: {
      nomohAdmin: 'w0htsn57sp', // Preencha com seu ID do painel Clarity
      nomohCliente: 'w0htcffxp1', // Preencha com seu ID do painel Clarity
      bardoAdmin: 'w0hsyihkm6', // Preencha com seu ID do painel Clarity
      bardoCliente: 'w0hy09xqoz', // Preencha com seu ID do painel Clarity
    },
    googleAdsEnabled: false,
    googleAdsId: 'AW-18237980302',
  },
  app: {
    name: 'Nomoh',
    version: '1.0.0',
    logLevel: 'error',
  },
  frontend: {
    bardoAdmin: 'https://bardo.nomoh.dev.br/',
    bardoCliente: 'https://bardo.nomoh.dev.br/',
    nomohAdmin: 'https://nomoh-administrador.nomoh.dev.br/',
    nomohCliente: 'https://nomoh.dev.br/',
  },
};
